import request from "../shared/http";

class ReportService {
  static async listReports() {
    const { data } = await request.get("/reports");
    return data;
  }

  static async runReport(params) {
    const { data } = await request.post("/reports/run", params);
    return data;
  }

  static async saveReport(params) {
    const { data } = await request.post("/reports", params);
    return data;
  }

  static async deleteReport(id) {
    const { data } = await request.delete(`/reports/${id}`);
    return data;
  }
}

export default ReportService;
